import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TrendingUp, Maximize2, Loader2 } from 'lucide-react';
import { apiRequest } from '../../lib/utils';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

export default function MyPerformanceWidget({ expandable, expandPath }) {
  const navigate = useNavigate();
  const [performance, setPerformance] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPerformance();
  }, []);

  const fetchPerformance = async () => {
    try {
      const data = await apiRequest('/performance-reviews/my-latest');
      setPerformance(data);
    } catch (error) {
      console.error('Failed to fetch performance');
    } finally {
      setLoading(false);
    }
  };

  const getScoreColor = (score) => {
    if (score >= 8) return 'text-green-600 bg-green-100';
    if (score >= 6) return 'text-amber-600 bg-amber-100';
    return 'text-red-600 bg-red-100';
  };

  return (
    <Card data-testid="my-performance-widget">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <TrendingUp className="h-5 w-5 text-indigo-500" />
            <CardTitle className="text-lg">My Performance</CardTitle>
          </div>
          {expandable && (
            <Button variant="ghost" size="icon" onClick={() => navigate(expandPath || '/my-performance')} className="h-8 w-8">
              <Maximize2 className="h-4 w-4" />
            </Button>
          )}
        </div>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="flex justify-center py-4">
            <Loader2 className="h-6 w-6 animate-spin text-slate-400" />
          </div>
        ) : !performance ? (
          <div className="text-center py-4 text-slate-400">
            <TrendingUp className="h-8 w-8 mx-auto mb-2 opacity-50" />
            <p className="text-sm">No recent reviews</p>
          </div>
        ) : (
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-sm text-slate-500">Latest Score</span>
              <div className={`px-3 py-1 rounded-full ${getScoreColor(performance.overall_score || 0)}`}>
                <span className="font-bold">{performance.overall_score || 'N/A'}/10</span>
              </div>
            </div>
            {performance.review_period && (
              <p className="text-xs text-slate-500">Period: {performance.review_period}</p>
            )}
            {performance.engagement_bonus > 0 && (
              <Badge className="bg-purple-100 text-purple-700">
                +{performance.engagement_bonus} Engagement Bonus
              </Badge>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
